import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Scrollbar } from 'components';
import { Checkbox } from '../Checkbox';
import ArrowDown from './arrow-down.svg';

class DropdownMulti extends PureComponent {
  constructor(props) {
    super(props);

    const { initMessage } = props;

    this.state = {
      listOpen: false,
      headerTitle: initMessage,
      searchValue: '',
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const result = {};
    const { initMessage } = nextProps;

    if (JSON.stringify(nextProps.value) !== JSON.stringify(prevState.value)) {
      const itemsArr = [];
      const titleArr = [];

      const helpArr = [...nextProps.value];
      helpArr.map((item) => {
        const newObjectItem = (nextProps.list || []).find(
          (listItem) => listItem.value === item || +listItem.value === +item,
        );
        itemsArr.push(newObjectItem);
      });

      itemsArr.length && itemsArr.map((item) => titleArr.push(item.title));

      result.value = nextProps.value;
      result.headerTitle = titleArr.length ? titleArr.join(', ') : initMessage;
    }

    return result;
  }

  componentDidUpdate(prevProps) {
    const { listOpen } = this.state;

    setTimeout(() => {
      if (listOpen) {
        window.addEventListener('click', this.close);
      } else {
        window.removeEventListener('click', this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.close);
  }

  close = () => {
    this.setState({
      listOpen: false,
    });
  };

  toggleList = () => {
    if (this.props.disabled) {
      return;
    }

    this.setState((prevState) => ({
      listOpen: !prevState.listOpen,
    }));
  };

  selectItem = (item) => {
    const { initMessage, value } = this.props;
    const { headerTitle } = this.state;
    const helpArr = [...value];

    let titleArr = headerTitle.split(',');

    titleArr.length === 1 &&
      (titleArr[0] === initMessage || titleArr[0] === '') &&
      titleArr.splice(0, 1);

    if (helpArr.includes(item.value)) {
      for (let i = 0; i < helpArr.length; i++) {
        if (item.value === helpArr[i]) {
          helpArr.splice(i, 1);
          titleArr.splice(i, 1);
        }
      }
    } else {
      helpArr.push(item.value);
      titleArr.push(item.title);
    }

    titleArr.length === 0 && titleArr.push(initMessage);

    const savedValue = helpArr;

    this.setState({
      headerTitle: titleArr.join(', '),
      value: savedValue,
    });
    this.props.onChange(savedValue);
  };

  render() {
    const {
      list,
      label,
      disabled,
      rowsCount,
      showAllOption,
      value,
      name,
      minAge,
      maxAge,
    } = this.props;
    const { listOpen, headerTitle, searchValue } = this.state;

    let displayedList = searchValue
      ? list.filter(
          (listItem) =>
            listItem.title.toUpperCase().indexOf(searchValue.toUpperCase()) !==
            -1,
        )
      : list;

    if (showAllOption && !searchValue) {
      displayedList = [{ value: null, title: 'All' }, ...displayedList];
    }
    const height =
      displayedList.length >= rowsCount
        ? rowsCount * 32
        : displayedList.length * 32;

    displayedList.map((item) => {
      item.disabled = !(
        (item.minMinAge === minAge && !item.maxMinAge) ||
        (item.minMinAge <= minAge && item.maxMinAge > minAge) ||
        (item.minMinAge > minAge && item.maxMinAge < maxAge) ||
        (item.minMinAge <= maxAge && item.maxMinAge >= maxAge)
      );
    });

    return (
      <div className="dd-wrapper" test-id={`dropdown-${name}`}>
        <div
          className={classnames('dd-header', { _disabled: disabled })}
          onClick={this.toggleList}
        >
          {label && <div className="dd-header-label">{label}</div>}
          <div className="dd-header-title multi-title">{headerTitle}</div>
          <ArrowDown
            style={{ minWidth: '12px' }}
            className={listOpen ? 'arrow-down' : ''}
          />
        </div>
        {listOpen && (
          <div
            style={{ height: `${height}px` }}
            className="dd-list drop-list"
            onClick={(e) => e.stopPropagation()}
          >
            <Scrollbar>
              <ul style={{ width: '100%' }}>
                {displayedList.map((item, index) => (
                  <li
                    test-id={`dropdown-item-${name}-${item.value}`}
                    key={index}
                  >
                    <Checkbox
                      name={item.value}
                      label={item.title}
                      isCheckedBox={
                        value.includes(item.value) && !item.disabled
                      }
                      addComponentClass={'multiCheckbox'}
                      isDisabledBox={item.disabled}
                      onChange={() => this.selectItem(item)}
                      conversely
                    />
                  </li>
                ))}
              </ul>
            </Scrollbar>
          </div>
        )}
      </div>
    );
  }
}

DropdownMulti.propTypes = {
  initMessage: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  list: PropTypes.array,
  disabled: PropTypes.bool,
  search: PropTypes.bool,
  rowsCount: PropTypes.number,
  showCheckIcon: PropTypes.bool,
  showAllOption: PropTypes.bool,
};

DropdownMulti.defaultProps = {
  initMessage: '',
  onChange: (e) => {},
  value: '',
  list: [],
  disabled: false,
  search: false,
  rowsCount: 6,
  showCheckIcon: false,
  showAllOption: false,
};

export default DropdownMulti;
